import React from "react";
import { Link } from "react-router-dom";
import { FiHome } from "react-icons/fi";
import { Button } from "../components/ui";

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-slate-50 px-4 text-center">
      <p className="text-6xl font-extrabold text-primary-600">404</p>
      <h1 className="mt-3 text-xl font-semibold text-slate-900">Page not found</h1>
      <p className="mt-1.5 max-w-sm text-sm text-slate-500">
        The page you're looking for doesn't exist or has moved.
      </p>
      <Link to="/dashboard" className="mt-6">
        <Button>
          <FiHome className="h-4 w-4" /> Back to dashboard
        </Button>
      </Link>
    </div>
  );
}
